import {useCallback, useState} from 'react';
import {jobDelete} from '../../api/callable/jobs';

export default function useDeleteJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const deleteJob = useCallback(async (id: string) => {
    setLoading(true);
    setError(undefined);
    try {
      return await jobDelete({id});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {deleteJob, loading, error};
}
